import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTrialModeNotificationChildQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTrialModeNotificationChildQuery = { __typename?: 'Query', wf_trialModeLeads_notificationChild?: { __typename?: 'WF_TrialModeLeads_NotificationChildConnection', nodes?: Array<{ __typename?: 'WF_TrialModeLeads_NotificationChild', notificationChildAge?: string | null, notificationChildAgeName?: string | null }> | null } | null };


export const GetTrialModeNotificationChildDocument = gql`
    query GetTrialModeNotificationChild {
  wf_trialModeLeads_notificationChild(order: {notificationChildAgeId: ASC}) {
    nodes {
      notificationChildAge
      notificationChildAgeName
    }
  }
}
    `;

/**
 * __useGetTrialModeNotificationChildQuery__
 *
 * To run a query within a React component, call `useGetTrialModeNotificationChildQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrialModeNotificationChildQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrialModeNotificationChildQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrialModeNotificationChildQuery(baseOptions?: Apollo.QueryHookOptions<GetTrialModeNotificationChildQuery, GetTrialModeNotificationChildQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrialModeNotificationChildQuery, GetTrialModeNotificationChildQueryVariables>(GetTrialModeNotificationChildDocument, options);
      }
export function useGetTrialModeNotificationChildLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrialModeNotificationChildQuery, GetTrialModeNotificationChildQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrialModeNotificationChildQuery, GetTrialModeNotificationChildQueryVariables>(GetTrialModeNotificationChildDocument, options);
        }
export type GetTrialModeNotificationChildQueryHookResult = ReturnType<typeof useGetTrialModeNotificationChildQuery>;
export type GetTrialModeNotificationChildLazyQueryHookResult = ReturnType<typeof useGetTrialModeNotificationChildLazyQuery>;
export type GetTrialModeNotificationChildQueryResult = Apollo.QueryResult<GetTrialModeNotificationChildQuery, GetTrialModeNotificationChildQueryVariables>;